export default "* Stammebåd\n* Hyld\n* Marv\n* Udhule";